import { debounce } from 'throttle-debounce'
import * as React from 'react'
import { connect } from 'react-redux'

import { setViewportSize } from 'embed/actions'

export interface ViewportSizeProviderDispatchProps {
  dispatchSetViewportSize: (height: number, width: number) => void
}

type Props = ViewportSizeProviderDispatchProps

const ViewportSizeProvider: React.FC<Props> = ({ dispatchSetViewportSize }) => {
  const updateViewportSize = React.useCallback(
    debounce(400, false, () => {
      const { innerHeight, innerWidth } = window
      dispatchSetViewportSize(innerHeight, innerWidth)
    }),
    [dispatchSetViewportSize],
  )

  React.useEffect(() => {
    updateViewportSize()
    window.addEventListener('resize', updateViewportSize)

    return () => {
      window.removeEventListener('resize', updateViewportSize)
    }
  }, [])

  return null
}

const mapDispatchToProps = (dispatch): ViewportSizeProviderDispatchProps => ({
  dispatchSetViewportSize: (height, width) => dispatch(setViewportSize(height, width)),
})

export default connect(undefined, mapDispatchToProps)(ViewportSizeProvider)
